var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { useIntersectionObserver } from '../use-intersection-observer';
import { ITrackType, useClickstreamAnalytics } from '../clickstream-analytics-context';
import { IntersectionTrackerTags, referrerMapper, uisMicroMessagesAggregator } from './util';
import { useEffect, useRef } from 'react';
import { useTimer } from '../use-timer';
import { usePageVisibility } from '../use-page-visibility';
export var IntersectionTimeTracker = function (_a) {
    var referrerId = _a.referrerId, linkName = _a.linkName, additionalUisPrimeMicroMessages = _a.additionalUisPrimeMicroMessages, delay = _a.delay, className = _a.className, _b = _a.trackOnce, trackOnce = _b === void 0 ? true : _b, intersectionOptions = _a.intersectionOptions, _c = _a.minTime, minTime = _c === void 0 ? 0 : _c, tag = _a.tag, children = _a.children;
    var track = useClickstreamAnalytics().track;
    var _d = __read(useTimer(), 3), isTimerActive = _d[0], startTimer = _d[1], stopTimer = _d[2];
    var isIntersecting = useRef();
    var intersectionObserverInstance = useRef();
    var isPageVisible = usePageVisibility();
    var Tag = ((tag && IntersectionTrackerTags.get(tag)) ||
        IntersectionTrackerTags.get('div'));
    var disconnectIntersectionObserver = function () {
        intersectionObserverInstance.current && intersectionObserverInstance.current.disconnect();
        isIntersecting.current = undefined;
    };
    var attemptTrackWithTime = function () {
        if (isTimerActive()) {
            var timeDiff = stopTimer();
            if (timeDiff !== undefined && timeDiff >= minTime) {
                track(ITrackType.EVENT, {
                    data: uisMicroMessagesAggregator(referrerMapper("".concat(referrerId, ".").concat(timeDiff), linkName, 'impression'), additionalUisPrimeMicroMessages),
                    config: { delay: delay }
                });
                if (trackOnce) {
                    disconnectIntersectionObserver();
                }
            }
        }
    };
    // When the user minimizes the window or switches to another tab
    if (isIntersecting.current) {
        if (!isPageVisible && isTimerActive()) {
            attemptTrackWithTime();
        }
        else if (isPageVisible && !isTimerActive()) {
            startTimer();
        }
    }
    var _e = __read(useIntersectionObserver(function (entries, intersection) {
        var _a = __read(entries, 1), entry = _a[0];
        isIntersecting.current = entry.isIntersecting;
        intersectionObserverInstance.current = intersection;
        if (!entry.isIntersecting) {
            attemptTrackWithTime();
        }
        if (entry.isIntersecting) {
            startTimer();
        }
    }, intersectionOptions), 1), setRef = _e[0];
    useEffect(function () {
        return function () {
            attemptTrackWithTime();
        };
    }, []);
    return (React.createElement(Tag, { ref: setRef, className: className }, children));
};
IntersectionTimeTracker.displayName = 'IntersectionTimeTracker';
//# sourceMappingURL=intersection-time-tracker.js.map